// Textos dos comparativos dos KPIs do Dashboard.
//
// As chaves do `switch` são rótulos internos e NÃO são exibidas: o que vai
// para a tela sai do i18n. O texto começa com ▲/▼ porque o card do mockup
// separa a seta do número (ver `deltaCompacto` em dashboardRules).
import { i18n } from "../../translate/i18n";

export const formatMilhar = (n) => Number(n || 0).toLocaleString("pt-BR");

const arrow = (up) => (up ? "▲" : "▼");

const estavel = () => ({
  text: i18n.t("aeros.dashboard.delta.stable"),
  tone: "neutral",
});

const pctDelta = (cur, prev, sufixoKey, upIsGood) => {
  if (!prev && !cur) return estavel();
  const sufixo = i18n.t(sufixoKey);
  if (!prev)
    return {
      text: `▲ +${cur} ${sufixo}`,
      tone: upIsGood ? "good" : "bad",
    };
  const diff = Math.round(((cur - prev) / prev) * 100);
  if (diff === 0) return estavel();
  const up = diff > 0;
  return {
    text: `${arrow(up)} ${Math.abs(diff)}% ${sufixo}`,
    tone: up === upIsGood ? "good" : "bad",
  };
};

export const buildKpiDelta = (label, counters = {}, comp, extras = {}) => {
  if (!comp) {
    if (label === "Atendentes Ativos" && extras.offlineCount != null)
      return {
        text: i18n.t("aeros.dashboard.delta.offline", {
          count: extras.offlineCount,
        }),
        tone: "neutral",
      };
    if (label === "Mensagens Recebidas" && extras.totalReceived != null)
      return {
        text: i18n.t("aeros.dashboard.delta.total", {
          value: formatMilhar(extras.totalReceived),
        }),
        tone: "neutral",
      };
    if (label === "Mensagens Enviadas" && extras.totalSent != null)
      return {
        text: i18n.t("aeros.dashboard.delta.total", {
          value: formatMilhar(extras.totalSent),
        }),
        tone: "neutral",
      };
    return null;
  }
  const pp = comp.previousPeriod || {};
  switch (label) {
    case "Em Atendimento":
      // Sem delta: supportHappening é contagem de ESTADO ATUAL (status='open',
      // sem filtro de data) — não há baseline histórico e a comparação sempre empataria.
      return null;
    case "Finalizados":
      return pctDelta(
        Number(counters.supportFinished) || 0,
        Number(pp.supportFinished) || 0,
        "aeros.dashboard.delta.inPeriod",
        true
      );
    case "Novos Contatos":
      return pctDelta(
        Number(counters.leads) || 0,
        Number(pp.leads) || 0,
        "aeros.dashboard.delta.inPeriod",
        true
      );
    case "Aguardando": {
      const diff =
        (Number(counters.supportPending) || 0) -
        (Number(comp.pendingOneHourAgo) || 0);
      if (diff === 0) return estavel();
      return {
        text: `${arrow(diff > 0)} ${Math.abs(diff)} ${i18n.t(
          "aeros.dashboard.delta.lastHour"
        )}`,
        tone: diff > 0 ? "bad" : "good",
      };
    }
    case "Grupos": {
      const diff =
        (Number(counters.supportGroups) || 0) - (Number(pp.supportGroups) || 0);
      if (diff === 0) return estavel();
      return { text: `${arrow(diff > 0)} ${Math.abs(diff)}`, tone: "neutral" };
    }
    case "T.M. de Atendimento":
    case "T.M. de Espera": {
      const isSupport = label === "T.M. de Atendimento";
      const cur =
        Number(isSupport ? counters.avgSupportTime : counters.avgWaitTime) || 0;
      const avg =
        Number(
          isSupport ? comp.historicalAvg?.supportTime : comp.historicalAvg?.waitTime
        ) || 0;
      const diff = Math.round(cur - avg);
      if (diff === 0)
        return { text: i18n.t("aeros.dashboard.delta.onAverage"), tone: "neutral" };
      return {
        text: `${arrow(diff > 0)} ${Math.abs(diff)} ${i18n.t(
          "aeros.dashboard.delta.vsAverage"
        )}`,
        tone: diff > 0 ? "bad" : "good",
      };
    }
    case "Tickets Ativos": {
      const n = Number(comp.today?.activeTickets) || 0;
      if (!n) return estavel();
      return {
        text: `▲ ${n} ${i18n.t("aeros.dashboard.delta.today")}`,
        tone: "bad",
      };
    }
    case "Tickets Passivos": {
      const n = Number(comp.today?.passiveTickets) || 0;
      if (!n) return estavel();
      return {
        text: `▲ ${n} ${i18n.t("aeros.dashboard.delta.today")}`,
        tone: "good",
      };
    }
    case "Atendentes Ativos":
      return extras.offlineCount != null
        ? {
            text: i18n.t("aeros.dashboard.delta.offline", {
              count: extras.offlineCount,
            }),
            tone: "neutral",
          }
        : null;
    case "Mensagens Recebidas":
      return extras.totalReceived != null
        ? {
            text: i18n.t("aeros.dashboard.delta.total", {
              value: formatMilhar(extras.totalReceived),
            }),
            tone: "neutral",
          }
        : null;
    case "Mensagens Enviadas":
      return extras.totalSent != null
        ? {
            text: i18n.t("aeros.dashboard.delta.total", {
              value: formatMilhar(extras.totalSent),
            }),
            tone: "neutral",
          }
        : null;
    default:
      return null;
  }
};
